import axios, { type AxiosInstance } from "axios";
import { apiClient } from "@/marketing/infrastructure/http/httpClient";
import type { CampaignInfluencerContact } from "@/marketing/models/campaignInfluencerContact";

export class UserAPIClient {
  constructor(private readonly client: AxiosInstance = apiClient) {}

  // GET /user?userId= — WordPress user email + shipping/billing address (admin API key).
  // Returns null when the user has no WP record (404), so the UI can show "no account".
  public async getUserContact(
    userId: number,
  ): Promise<CampaignInfluencerContact | null> {
    try {
      const { data } = await this.client.get<CampaignInfluencerContact>("/user", {
        params: { userId },
      });
      return data;
    } catch (error) {
      if (axios.isAxiosError(error) && error.response?.status === 404) return null;
      throw error;
    }
  }
}

export const userAPIClient = new UserAPIClient();
